import { combineReducers } from "redux";
import { reducer as form } from "redux-form";

import user from "./User";
import property from "./Property";
import survey from "./Survey";
import dropDown from "./DropDown";
import taxCollection from "./TaxCollection";
import changeRequest from "./ChangeRequest";
import zones from "./Zones";
import homePage from "./HomePage";
import eto from "./ETO";
import taxInspector from "./TaxInspector"
import circles from "./Circles"
import tehsile from "./Tehsiles"
import mouza from "./Mouza";
import districtAdmin from "./DistrictAdmin";

export default combineReducers({
  user,
  property,
  survey,
  dropDown,
  taxCollection,
  changeRequest,
  form,
  zones,
  homePage,
  eto,
  taxInspector,
  circles,
  tehsile,
  mouza,
  districtAdmin
});
